import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { Category } from '../models/category.type';

export class CategoryMapper extends BaseMapper<Category> {
   
}
